// EDIFACT Glossar - Alle wichtigen Begriffe strukturiert
export const glossaryTerms = [
  // ========== SEGMENTE ==========
  {
    slug: "unb",
    term: "UNB",
    category: "Segment",
    fullName: "Interchange Header",
    description:
      "Das UNB-Segment markiert den Start eines EDIFACT-Interchanges. Es enthält grundlegende Informationen wie Absender, Empfänger, Syntax-Version und Zeitstempel.",
    example: "UNB+UNOC:3+SENDER+RECEIVER+20250105:1430+000000001'",
    structure:
      "Vereinfachte Struktur: UNB+Syntax-ID:Version+Absender+Empfänger+Datum:Zeit+Interchange-Referenz'",
    usage:
      "Pflichtsegment am Anfang eines Interchanges. Pro Interchange gibt es genau ein UNB/UNZ-Paar; eine physische Datei kann mehrere Interchanges hintereinander enthalten.",
    relatedTerms: ["unz", "interchange", "syntax-version", "una"],
    relatedTools: ["/edifact-viewer", "/edifact-validator"],
  },
  {
    slug: "una",
    term: "UNA",
    category: "Segment",
    fullName: "Service String Advice",
    description:
      "Das UNA-Segment definiert die in einer EDIFACT-Datei verwendeten Trenn- und Steuerzeichen. Es ist optional und steht – wenn verwendet – immer ganz am Anfang, noch vor UNB. Häufig verwendete Voreinstellung: UNA:+.? '",
    example: "UNA:+.? '",
    structure:
      "UNA:+.? ' (6 Zeichen: Komponenten-Trenner, Datenelement-Trenner, Dezimalzeichen, Release-Zeichen, Wiederholungs-Trennzeichen bzw. reserviert (abhängig von der Syntaxebene), Segmentabschluss)",
    usage:
      "Optional. Wenn vorhanden, muss es das allererste Element des Interchanges sein und legt die Trennzeichen für die gesamte Datei fest.",
    relatedTerms: ["unb", "trennzeichen"],
    relatedTools: ["/edifact-viewer", "/edifact-formatter"],
  },
  {
    slug: "unh",
    term: "UNH",
    category: "Segment",
    fullName: "Message Header",
    description:
      "Das UNH-Segment markiert den Beginn einer EDIFACT-Nachricht innerhalb eines Interchanges. Es identifiziert den Nachrichtentyp (z.B. INVOIC, ORDERS) und die Version.",
    example: "UNH+1+INVOIC:D:96A:UN'",
    structure:
      "Vereinfachte Struktur: UNH+Nachrichtenreferenz+Nachrichtentyp:Version:Release:Kontrollstelle'",
    usage:
      "Pflichtsegment am Anfang jeder Nachricht. Muss paarweise mit einem UNT-Segment am Nachrichtenende auftreten.",
    relatedTerms: ["unt", "invoic", "orders", "nachrichtentyp"],
    relatedTools: ["/edifact-viewer", "/edifact-validator"],
  },
  {
    slug: "unt",
    term: "UNT",
    category: "Segment",
    fullName: "Message Trailer",
    description:
      "Das UNT-Segment markiert das Ende einer EDIFACT-Nachricht. Es enthält die Anzahl der Segmente zwischen UNH und UNT (inklusive) zur Validierung der Nachricht.",
    example: "UNT+15+1'",
    structure: "Vereinfachte Struktur: UNT+Anzahl_Segmente+Nachrichtenreferenz'",
    usage:
      "Pflichtsegment am Ende jeder Nachricht. Muss zur Nachrichtenreferenz im zugehörigen UNH-Segment passen.",
    relatedTerms: ["unh", "segmentanzahl"],
    relatedTools: ["/edifact-validator"],
  },
  {
    slug: "unz",
    term: "UNZ",
    category: "Segment",
    fullName: "Interchange Trailer",
    description:
      "Das UNZ-Segment markiert das Ende eines EDIFACT-Interchanges. Es enthält die Anzahl der Nachrichten (oder funktionalen Gruppen) im Interchange zur Validierung.",
    example: "UNZ+1+000000001'",
    structure:
      "Vereinfachte Struktur: UNZ+Anzahl_Nachrichten+Interchange-Referenz'",
    usage:
      "Pflichtsegment am Ende eines Interchanges. Die Interchange-Referenz muss der Referenz aus UNB entsprechen.",
    relatedTerms: ["unb", "interchange", "ung", "une"],
    relatedTools: ["/edifact-validator"],
  },
  {
    slug: "ung",
    term: "UNG",
    category: "Segment",
    fullName: "Functional Group Header",
    description:
      "Das UNG-Segment markiert den Beginn einer funktionalen Gruppe. Es wird verwendet, um mehrere Nachrichten desselben Typs (z.B. mehrere INVOIC) innerhalb eines Interchanges zu gruppieren.",
    example: "UNG+INVOIC+SENDER+RECEIVER+20250105:1430+1+UN+D96A'",
    structure:
      "Vereinfachte Struktur: UNG+Nachrichtentyp+Absender+Empfänger+Datum:Zeit+Gruppen-Referenz+Agentur+Version'",
    usage:
      "Optional. Wenn UNG verwendet wird, müssen alle Nachrichten zwischen UNG und UNE vom gleichen Nachrichtentyp sein.",
    relatedTerms: ["une", "unb", "unh"],
    relatedTools: ["/edifact-viewer", "/edifact-validator"],
  },
  {
    slug: "une",
    term: "UNE",
    category: "Segment",
    fullName: "Functional Group Trailer",
    description:
      "Das UNE-Segment schließt eine funktionale Gruppe ab. Es enthält die Anzahl der Nachrichten in der Gruppe und die Gruppen-Referenz zur Validierung.",
    example: "UNE+3+1'",
    structure: "Vereinfachte Struktur: UNE+Anzahl_Nachrichten+Gruppen-Referenz'",
    usage:
      "Pflichtsegment, wenn UNG verwendet wurde. Muss zur Referenz im UNG-Segment passen.",
    relatedTerms: ["ung", "unz", "unt"],
    relatedTools: ["/edifact-viewer", "/edifact-validator"],
  },
  {
    slug: "bgm",
    term: "BGM",
    category: "Segment",
    fullName: "Beginning of Message",
    description:
      "Das BGM-Segment identifiziert den Dokumenttyp und enthält typischerweise eine Belegnummer. In den meisten Handelsnachrichten ist es das erste fachliche Datensegment nach UNH und legt fest, um welche Art von Geschäftsdokument es sich handelt.",
    example: "BGM+380+INV-2025-001+9'",
    structure:
      "Vereinfachte Struktur: BGM+Dokumenttyp+Belegnummer+Nachrichtenfunktion'",
    usage:
      "In gängigen Handelsnachrichten (z.B. INVOIC, ORDERS, DESADV) ein zentrales Pflichtsegment im Kopfbereich (abhängig vom eingesetzten Nachrichten-/Branchenprofil).",
    relatedTerms: ["dokumenttyp", "belegnummer"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "dtm",
    term: "DTM",
    category: "Segment",
    fullName: "Date/Time/Period",
    description:
      "Das DTM-Segment enthält Datums- und Zeitangaben mit einem Qualifier, der die Bedeutung des Datums angibt (z.B. Rechnungsdatum, Lieferdatum).",
    example: "DTM+137:20250105:102'",
    structure:
      "Vereinfachte Struktur: DTM+Qualifier:Datum:Format'",
    usage:
      "Je nach Nachrichtentyp mehrfach verwendbar, z.B. für Rechnungsdatum, Lieferdatum oder Bestelldatum. Qualifier und Format richten sich nach UNTDID und ggf. Branchenprofil (z.B. EANCOM).",
    relatedTerms: ["datumsformat", "qualifier"],
    relatedTools: ["/edifact-validator"],
  },
  {
    slug: "nad",
    term: "NAD",
    category: "Segment",
    fullName: "Name and Address",
    description:
      "Das NAD-Segment enthält Informationen über beteiligte Parteien (z.B. Käufer, Verkäufer, Lieferant). Es wird mit einem Qualifier gekennzeichnet (z.B. BY=Käufer, SU=Verkäufer).",
    example: "NAD+BY+1234567890123::9'",
    structure:
      "Vereinfachte Struktur: NAD+Qualifier+Parteien-ID::ID-Typ+Name+Straße+Stadt+PLZ+Land'",
    usage:
      "In typischen Handelsnachrichten werden mindestens Käufer (NAD+BY) und Verkäufer (NAD+SU) angegeben; genaue Pflicht-/Kann-Regeln hängen vom jeweiligen Profil ab.",
    relatedTerms: ["gln", "qualifier", "by", "su"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "lin",
    term: "LIN",
    category: "Segment",
    fullName: "Line Item",
    description:
      "Das LIN-Segment markiert den Beginn einer Positionszeile in einer Bestellung oder Rechnung. Es enthält die Positionsnummer und optional eine oder mehrere Artikelidentifikationen.",
    example: "LIN+1++4012345678901:EN'",
    structure:
      "Vereinfachte Struktur: LIN+Positionsnummer++Artikelnummer:Nummernart'",
    usage:
      "Kann mehrfach vorkommen, jeweils einmal pro Positionszeile. Weitere Artikelnummern können über nachfolgende PIA-Segmente angegeben werden.",
    relatedTerms: ["position", "artikelnummer", "ean"],
    relatedTools: ["/edifact-viewer", "/edi-konverter"],
  },
  {
    slug: "qty",
    term: "QTY",
    category: "Segment",
    fullName: "Quantity",
    description:
      "Das QTY-Segment gibt Mengenangaben an, z.B. bestellte Menge, gelieferte Menge oder verfügbare Menge. Der Qualifier bestimmt die Art der Menge.",
    example: "QTY+47:100'",
    structure:
      "Vereinfachte Struktur: QTY+Qualifier:Menge:Einheit'",
    usage:
      "Kann in einer Nachricht mehrfach vorkommen, z.B. pro Position oder pro Verpackungseinheit. Verwendete Qualifier sind durch UNTDID und ggf. Branchenprofile definiert.",
    relatedTerms: ["menge", "qualifier"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "pri",
    term: "PRI",
    category: "Segment",
    fullName: "Price Details",
    description:
      "Das PRI-Segment enthält Preisinformationen für eine Position. Der Qualifier gibt an, um welche Art von Preis es sich handelt (z.B. Listenpreis, Nettopreis).",
    example: "PRI+AAA:19.99'",
    structure:
      "Vereinfachte Struktur: PRI+Qualifier:Preis:Preistyp'",
    usage:
      "Wird häufig in Bestellungen und Rechnungen pro Position verwendet. Die genaue Belegung orientiert sich an UNTDID und Branchenprofil (z.B. EANCOM).",
    relatedTerms: ["preis", "qualifier"],
    relatedTools: ["/edifact-viewer", "/edi-konverter"],
  },
  {
    slug: "moa",
    term: "MOA",
    category: "Segment",
    fullName: "Monetary Amount",
    description:
      "Das MOA-Segment enthält Geldbeträge mit einem Qualifier (z.B. Gesamtbetrag, Steuerbetrag, Nettobetrag).",
    example: "MOA+9:1999.00'",
    structure:
      "Vereinfachte Struktur: MOA+Qualifier:Betrag:Währung'",
    usage:
      "Kann sowohl auf Kopf- als auch auf Positionsebene verwendet werden, z.B. Gesamtbetrag der Rechnung oder Nettobetrag einer Position. Die Verwendung der Währung kann auch über CUX gesteuert werden.",
    relatedTerms: ["betrag", "qualifier", "waehrung"],
    relatedTools: ["/edifact-viewer", "/edi-konverter"],
  },
  {
    slug: "cnt",
    term: "CNT",
    category: "Segment",
    fullName: "Control Total",
    description:
      "Das CNT-Segment enthält Kontrollsummen, z.B. die Anzahl der Positionen oder eine Gesamtmenge. Es dient der Plausibilitäts- und Vollständigkeitsprüfung.",
    example: "CNT+2:10'",
    structure: "Vereinfachte Struktur: CNT+Qualifier:Wert'",
    usage:
      "Optionales Kontrollsegment, z.B. zur Angabe der Anzahl von LIN-Segmenten oder Gesamtmengen. Verwendete Qualifier sind in UNTDID definiert.",
    relatedTerms: ["kontrolle", "qualifier"],
    relatedTools: ["/edifact-validator"],
  },
  {
    slug: "rff",
    term: "RFF",
    category: "Segment",
    fullName: "Reference",
    description:
      "Das RFF-Segment enthält Referenzen wie Bestellnummer, Lieferscheinnummer, Kundennummer oder andere Identifikationsnummern zur Zuordnung der Nachricht.",
    example: "RFF+ON:ORDER12345'",
    structure:
      "Vereinfachte Struktur: RFF+Qualifier:Referenznummer'",
    usage:
      "Wird verwendet, um Beziehungen zu anderen Dokumenten herzustellen. Der Qualifier (z.B. ON=Order Number) bestimmt die Art der Referenz; weitere Codes hängen vom eingesetzten Branchenprofil ab.",
    relatedTerms: ["bgm", "nad", "dtm"],
    relatedTools: ["/edifact-viewer", "/edifact-formatter"],
  },
  {
    slug: "cux",
    term: "CUX",
    category: "Segment",
    fullName: "Currencies",
    description:
      "Das CUX-Segment definiert die verwendeten Währungen in einer EDIFACT-Nachricht, z.B. Rechnungswährung, Referenzwährung oder Bestellwährung. Es basiert u.a. auf dem Composite C504 (Currency Details).",
    example: "CUX+2:EUR:9'",
    structure:
      "Vereinfachte Struktur: CUX+Verwendungsqualifier:Währungscode:Währungstyp'",
    usage:
      "Der Verwendungsqualifier (z.B. 2) kennzeichnet in vielen Profilen die Referenz- bzw. Basiswährung. Im Beispiel „CUX+2:EUR:9'“ steht EUR für den ISO-4217-Währungscode. Der Wert 9 für den Währungstyp (z.B. „Währung der Bestellung“) ist profilabhängig und wird in Branchen-/Partnerprofilen (z.B. EANCOM-Implementierungen) konkret festgelegt.",
    relatedTerms: ["moa", "pri", "waehrung"],
    relatedTools: ["/edifact-viewer", "/edifact-konverter"],
  },
  {
    slug: "tax",
    term: "TAX",
    category: "Segment",
    fullName: "Duty/Tax/Fee Details",
    description:
      "Das TAX-Segment enthält Informationen zu Steuern, Zöllen und Gebühren, z.B. Mehrwertsteuer (VAT), Umsatzsteuer oder andere Abgaben.",
    example: "TAX+7+VAT+++:::19'",
    structure:
      "Vereinfachte Struktur: TAX+Funktion+Steuertyp+++:::Steuersatz'",
    usage:
      "Typischerweise in Rechnungen (INVOIC) verwendet. Funktion 7 steht für Steuerangaben (Tax), VAT kennzeichnet die Mehrwertsteuer. Die genaue Verwendung der Composite-Elemente richtet sich nach UNTDID und dem eingesetzten Branchenprofil (z.B. EANCOM).",
    relatedTerms: ["moa", "invoic"],
    relatedTools: ["/edifact-viewer", "/edifact-konverter"],
  },
  {
    slug: "tdt",
    term: "TDT",
    category: "Segment",
    fullName: "Transport Details",
    description:
      "Das TDT-Segment enthält Details zum Transport wie Transportstufe, Transportart, Transportmittel oder Spediteur.",
    example: "TDT+20++30+31'",
    structure:
      "Vereinfachte Struktur: TDT+Transportstufe++Transportart+Transportmittel'",
    usage:
      "Wichtig z.B. in DESADV (Lieferavis). Der Qualifier 20 kennzeichnet gemäß UNTDID die Haupttransportstufe (Main-carriage transport). In vielen GS1/EANCOM-Profilen steht der Code 30 im Composite C220 für Straßentransport (Road transport).",
    relatedTerms: ["desadv", "loc", "pac"],
    relatedTools: ["/edifact-viewer", "/edifact-formatter"],
  },
  {
    slug: "pac",
    term: "PAC",
    category: "Segment",
    fullName: "Package",
    description:
      "Das PAC-Segment beschreibt Verpackungseinheiten wie Anzahl Pakete, Paletten oder Kartons sowie ggf. deren Typ.",
    example: "PAC+10++CT'",
    structure:
      "Vereinfachte Struktur: PAC+Anzahl++Verpackungstyp'",
    usage:
      "Häufig in DESADV verwendet. Typ-Codes können z.B. CT (Carton/Karton) oder PAL (Pallet/Palette) sein. Die detaillierte Struktur ist in UNTDID beschrieben.",
    relatedTerms: ["desadv", "tdt", "qty"],
    relatedTools: ["/edifact-viewer", "/edifact-formatter"],
  },
  {
    slug: "loc",
    term: "LOC",
    category: "Segment",
    fullName: "Place/Location Identification",
    description:
      "Das LOC-Segment identifiziert Orte und Standorte wie Lieferort, Ladeort, Entladeort oder Bestimmungsort mithilfe von Codes.",
    example: "LOC+7+DE12345::9'",
    structure:
      "Vereinfachte Struktur: LOC+Qualifier+Ort-ID::Code-Liste'",
    usage:
      "Der Qualifier 7 kennzeichnet in vielen GS1/EANCOM-Profilen den Lieferort (Place of delivery). Die Code-Liste 9 steht dabei für Codes nach EAN/GS1 (z.B. GLN-basierte Standortcodes). Andere Qualifier und Codelisten sind in UNTDID definiert.",
    relatedTerms: ["nad", "desadv", "tdt"],
    relatedTools: ["/edifact-viewer", "/edifact-formatter"],
  },

  // ========== NACHRICHTENTYPEN ==========
  {
    slug: "invoic",
    term: "INVOIC",
    category: "Nachrichtentyp",
    fullName: "Invoice Message",
    description:
      "INVOIC ist der EDIFACT-Standardnachrichtentyp für elektronische Rechnungen. Er enthält alle rechnungsrelevanten Informationen wie Positionen, Preise, Steuern und Zahlungsbedingungen.",
    example: "UNH+1+INVOIC:D:96A:UN'",
    structure:
      "Vereinfachte typische Struktur: UNH → BGM → DTM → NAD → LIN → QTY → PRI → MOA → TAX/CNT → UNT (konkrete Segmentgruppen je nach Version/Profil)",
    usage:
      "Einer der am häufigsten eingesetzten Nachrichtentypen im B2B-Bereich für elektronische Rechnungen. Exakte Segmentreihenfolge und Pflichtfelder werden durch UNTDID und das jeweilige Implementierungsprofil festgelegt.",
    relatedTerms: ["rechnung", "unh", "nachrichtentyp"],
    relatedTools: [
      "/edifact-viewer",
      "/edi-konverter",
      "/edifact-excel-konverter",
    ],
  },
  {
    slug: "orders",
    term: "ORDERS",
    category: "Nachrichtentyp",
    fullName: "Purchase Order Message",
    description:
      "ORDERS ist der EDIFACT-Standardnachrichtentyp für elektronische Bestellungen. Er enthält bestellrelevante Informationen wie Artikel, Mengen, Liefertermine und Lieferadressen.",
    example: "UNH+1+ORDERS:D:96A:UN'",
    structure:
      "Vereinfachte typische Struktur: UNH → BGM → DTM → NAD → LIN → QTY → PRI → UNT (konkrete Segmentgruppen je nach Version/Profil)",
    usage:
      "Standardnachrichtentyp für B2B-Bestellungen. Die genaue Ausprägung (z.B. EANCOM ORDERS D.96A) wird über Implementierungsrichtlinien bestimmt.",
    relatedTerms: ["bestellung", "unh", "nachrichtentyp"],
    relatedTools: ["/edifact-viewer", "/edi-konverter"],
  },
  {
    slug: "desadv",
    term: "DESADV",
    category: "Nachrichtentyp",
    fullName: "Despatch Advice Message",
    description:
      "DESADV ist der EDIFACT-Standardnachrichtentyp für Lieferavise. Er informiert den Empfänger über eine bevorstehende oder bereits erfolgte Lieferung mit Details zu Artikeln, Mengen, Verpackung und Lieferort.",
    example: "UNH+1+DESADV:D:96A:UN'",
    structure:
      "Vereinfachte typische Struktur: UNH → BGM → DTM → NAD → LOC → TDT → PAC → LIN → QTY → UNT (konkrete Segmentgruppen je nach Version/Profil)",
    usage:
      "Wichtiger Nachrichtentyp für Logistik- und Warenwirtschaftsprozesse. Die exakte Struktur wird durch UNTDID und Branchenprofile (z.B. EANCOM DESADV) festgelegt.",
    relatedTerms: ["lieferavis", "unh", "nachrichtentyp"],
    relatedTools: ["/edifact-viewer", "/edi-konverter"],
  },
  {
    slug: "ordrsp",
    term: "ORDRSP",
    category: "Nachrichtentyp",
    fullName: "Purchase Order Response Message",
    description:
      "ORDRSP ist die Auftragsbestätigung als Antwort auf eine ORDERS-Nachricht. Sie bestätigt, ändert oder lehnt bestellte Positionen und Liefertermine ab.",
    example: "UNH+1+ORDRSP:D:96A:UN'",
    structure:
      "Vereinfachte typische Struktur: UNH → BGM → DTM → NAD → LIN → QTY → UNT (konkrete Segmentgruppen je nach Version/Profil)",
    usage:
      "Antwortnachricht auf Bestellungen (ORDERS), z.B. zur Bestätigung oder Änderung von Mengen und Terminen.",
    relatedTerms: ["auftragsbestaetigung", "orders"],
    relatedTools: ["/edifact-viewer"],
  },

  // ========== QUALIFIER ==========
  {
    slug: "by",
    term: "BY",
    category: "Qualifier",
    fullName: "Buyer (Käufer)",
    description:
      "BY ist ein NAD-Qualifier und kennzeichnet den Käufer bzw. Besteller in einer EDIFACT-Nachricht.",
    example: "NAD+BY+1234567890123::9'",
    usage:
      "Wird im NAD-Segment verwendet, um die Käuferpartei eindeutig zu identifizieren. Die genaue Interpretation der ID (z.B. GLN) hängt von der verwendeten Codeliste ab.",
    relatedTerms: ["nad", "qualifier", "su"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "su",
    term: "SU",
    category: "Qualifier",
    fullName: "Supplier (Lieferant/Verkäufer)",
    description:
      "SU ist ein NAD-Qualifier und kennzeichnet den Lieferanten bzw. Verkäufer in einer EDIFACT-Nachricht.",
    example: "NAD+SU+9876543210987::9'",
    usage:
      "Wird im NAD-Segment verwendet, um die Lieferanten- bzw. Verkäuferpartei zu kennzeichnen.",
    relatedTerms: ["nad", "qualifier", "by"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "dp",
    term: "DP",
    category: "Qualifier",
    fullName: "Delivery Party (Lieferadresse)",
    description:
      "DP ist ein NAD-Qualifier und kennzeichnet die Lieferadresse in einer EDIFACT-Nachricht.",
    example: "NAD+DP++Musterfirma+Musterstraße 1+Musterstadt+12345+DE'",
    usage:
      "Wird im NAD-Segment verwendet, wenn die Lieferadresse von der Käufer- oder Rechnungsadresse abweicht.",
    relatedTerms: ["nad", "qualifier"],
    relatedTools: ["/edifact-viewer"],
  },

  // ========== ALLGEMEINE BEGRIFFE ==========
  {
    slug: "edifact",
    term: "EDIFACT",
    category: "Standard",
    fullName:
      "Electronic Data Interchange For Administration, Commerce and Transport",
    description:
      "EDIFACT ist der internationale UN-Standard (UN/CEFACT) für den elektronischen Datenaustausch (EDI) im Geschäftsverkehr. Er definiert Syntaxregeln sowie Formate und Strukturen für Geschäftsdokumente wie Rechnungen, Bestellungen und Lieferavise.",
    usage:
      "Weltweit verbreiteter EDI-Standard, insbesondere in Europa und im GS1-Umfeld.",
    relatedTerms: ["edi", "un-edifact", "interchange", "untdid"],
    relatedTools: [
      "/edi-konverter",
      "/edifact-viewer",
      "/edifact-formatter",
      "/edifact-validator",
    ],
  },
  {
    slug: "untdid",
    term: "UNTDID",
    category: "Standard",
    fullName: "UN Trade Data Interchange Directory",
    description:
      "UNTDID ist das offizielle Verzeichnis der UN/EDIFACT-Standards. Es enthält die Definitionen für Segmente, Datenelemente, Codes und Nachrichtentypen mit ihrer genauen Bedeutung und Verwendung.",
    example: "Beispiele für Versionen: D.96A, D.01B, D.03A, D.16B",
    structure:
      "Versionierungsschema: D.YYV (YY=Jahr, V=Version A/B usw., z.B. D.96A für das erste Verzeichnis des Jahres 1996).",
    usage:
      "Zentrale Referenz für EDIFACT-Implementierungen. Definiert verbindliche Strukturen, Codelisten und Regeln.",
    relatedTerms: ["edifact", "syntax-version"],
    relatedTools: ["/edifact-viewer", "/edifact-validator"],
  },
  {
    slug: "interchange",
    term: "Interchange",
    category: "Konzept",
    fullName: "EDIFACT-Interchange / Austausch",
    description:
      "Ein Interchange ist eine komplette EDIFACT-Einheit, die zwischen UNB und UNZ eingeschlossen ist. Er kann eine oder mehrere Nachrichten und optional funktionale Gruppen (UNG/UNE) enthalten.",
    structure: "UNB → [UNG →] (UNH → ... → UNT) [→ UNE] → UNZ",
    usage:
      "Technischer Begriff für den gesamten EDIFACT-Austausch zwischen zwei Partnern.",
    relatedTerms: ["unb", "unz", "nachricht"],
    relatedTools: ["/edifact-viewer", "/edifact-validator"],
  },
  {
    slug: "segment",
    term: "Segment",
    category: "Konzept",
    fullName: "EDIFACT-Segment",
    description:
      "Ein Segment ist eine logische Dateneinheit in EDIFACT, bestehend aus einem Segment-Tag (z.B. UNB, NAD) und einer definierten Folge von Datenelementen.",
    example: "NAD+BY+1234567890123::9'",
    structure: "TAG+Element1+Element2+...'",
    usage:
      "Segmente sind die strukturellen Bausteine jeder EDIFACT-Nachricht.",
    relatedTerms: ["datenelement", "tag"],
    relatedTools: ["/edifact-viewer", "/edifact-formatter"],
  },
  {
    slug: "datenelement",
    term: "Datenelement",
    category: "Konzept",
    fullName: "Data Element",
    description:
      "Ein Datenelement ist ein einzelnes Datenfeld innerhalb eines Segments, z.B. eine ID-Nummer, ein Datum oder ein Betrag. Datenelemente können einfach oder Teil eines zusammengesetzten Datenelements (Komponente) sein.",
    example: "1234567890123::9 (ID::Typ)",
    usage:
      "Kleinste logisch adressierbare Dateneinheit in EDIFACT-Segmenten.",
    relatedTerms: ["segment", "komponente"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "qualifier",
    term: "Qualifier",
    category: "Konzept",
    fullName: "Qualifier / Kennzeichen",
    description:
      "Ein Qualifier ist ein Code, der die Bedeutung eines Datenelements oder Segments präzisiert. Beispiel: Bei NAD kennzeichnet BY den Käufer, SU den Lieferanten.",
    example: "NAD+BY (BY ist Qualifier für 'Buyer')",
    usage:
      "Wird verwendet, um denselben Datenfeldern je nach Kontext eine unterschiedliche Rolle zu geben. Die zulässigen Qualifier sind in UNTDID bzw. Branchenprofilen definiert.",
    relatedTerms: ["by", "su", "dp"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "gln",
    term: "GLN",
    category: "Standard",
    fullName: "Global Location Number",
    description:
      "Die GLN ist eine international eindeutige 13-stellige Nummer zur Identifikation von Unternehmen, Standorten oder rechtlichen Einheiten. Sie wird häufig in NAD- oder LOC-Segmenten verwendet.",
    example: "NAD+BY+1234567890123::9'",
    usage:
      "Standardisierte Kennzeichnung von Geschäftspartnern und Standorten im GS1/EDIFACT-Umfeld.",
    relatedTerms: ["nad", "ean"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "ean",
    term: "EAN",
    category: "Standard",
    fullName: "European Article Number / GTIN",
    description:
      "Die EAN (heute GTIN) ist ein internationaler Standard für Artikelnummern und Strichcodes. In EDIFACT wird sie z.B. in LIN-Segmenten zur Artikelidentifikation verwendet.",
    example: "LIN+1++4012345678901:EN'",
    usage:
      "Standard-Artikelnummer im GS1-System, häufige Identifikation in Bestellungen und Rechnungen.",
    relatedTerms: ["lin", "artikelnummer"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "syntax-version",
    term: "Syntax-Version",
    category: "Konzept",
    fullName: "EDIFACT Syntax Version",
    description:
      "Die Syntax-Version definiert, welche EDIFACT-Syntaxebene verwendet wird (z.B. UNOC:3 oder UNOA:1). Sie wird im UNB-Segment angegeben und legt u.a. den erlaubten Zeichensatz und die verfügbaren Steuerzeichen fest.",
    example: "UNB+UNOC:3+...",
    usage:
      "UNOC:3 ist im europäischen Umfeld am gebräuchlichsten, da es u.a. Umlaute unterstützt. Die zulässigen Syntax-IDs und Versionen sind in UNTDID definiert.",
    relatedTerms: ["unb", "zeichensatz"],
    relatedTools: ["/edifact-validator"],
  },
  {
    slug: "nachrichtentyp",
    term: "Nachrichtentyp",
    category: "Konzept",
    fullName: "Message Type",
    description:
      "Der Nachrichtentyp definiert die Art des Geschäftsdokuments (z.B. INVOIC=Rechnung, ORDERS=Bestellung, DESADV=Lieferavis). Er wird im UNH-Segment angegeben und bestimmt Aufbau und Segmente der Nachricht.",
    example: "UNH+1+INVOIC:D:96A:UN'",
    usage:
      "Nachrichtentyp und Version (z.B. INVOIC D.96A) müssen zwischen allen beteiligten Partnern abgestimmt sein. Die formale Definition erfolgt in UNTDID; Branchenprofile (z.B. EANCOM) schränken die Verwendung weiter ein.",
    relatedTerms: ["invoic", "orders", "desadv", "unh"],
    relatedTools: ["/edifact-viewer"],
  },
  {
    slug: "trennzeichen",
    term: "Trennzeichen",
    category: "Konzept",
    fullName: "Delimiter / Separator",
    description:
      "EDIFACT verwendet spezielle Trennzeichen: ' als Segment-Ende, + als Datenelement-Trenner und : als Komponenten-Trenner. Diese Zeichen können im optionalen UNA-Segment überschrieben werden.",
    example: "UNA:+.? ' (definiert Trennzeichen und Steuerzeichen)",
    usage:
      "Ohne UNA gelten die in der jeweiligen Syntaxebene (z.B. UNOC/UNOA) definierten Standardtrennzeichen.",
    relatedTerms: ["una", "syntax"],
    relatedTools: ["/edifact-formatter"],
  },
];

// Kategorien für die Navigation
export const categories = [
  { id: "segment", name: "Segmente", icon: "📄" },
  { id: "nachrichtentyp", name: "Nachrichtentypen", icon: "📨" },
  { id: "qualifier", name: "Qualifier", icon: "🏷️" },
  { id: "standard", name: "Standards", icon: "⚙️" },
  { id: "konzept", name: "Konzepte", icon: "💡" },
];

// Hilfsfunktionen
export const getTermBySlug = (slug) => {
  return glossaryTerms.find((term) => term.slug === slug);
};

export const getTermsByCategory = (category) => {
  return glossaryTerms.filter(
    (term) => term.category.toLowerCase() === category.toLowerCase()
  );
};

export const getAllTermsAlphabetically = () => {
  return glossaryTerms.slice().sort((a, b) => a.term.localeCompare(b.term));
};

export const searchTerms = (query) => {
  const lowerQuery = query.toLowerCase();
  return glossaryTerms.filter(
    (term) =>
      term.term.toLowerCase().includes(lowerQuery) ||
      term.fullName.toLowerCase().includes(lowerQuery) ||
      term.description.toLowerCase().includes(lowerQuery)
  );
};
